<!--suppress JSUnresolvedVariable -->
<template>
  <div class="privacy-policy">
    <div
      class="top jumbotron jumbotron-fluid mb-2"
      :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-success">
        <h1 class="animated fadeInDown">隐私政策</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>
    <div class="content container my-5">
      <!-- 面包屑导航 -->
      <div class=" text-right position mb-3 d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <a href="#" class="text-muted">隐私政策</a>
      </div>
      <div class="row" v-html="article.articleContent"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      sectionSubTitle: "",
      backgroundUrl: "",
      article: {}
    };
  },
  mounted() {
    this.getNavById();
    this.getArticleById();
  },
  methods: {
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 8)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.backgroundUrl = resp.data.data.bannerImg;
            this.sectionSubTitle = resp.data.data.subTitle;
          }
        })
        .catch();
    },
    getArticleById() {
      this.axios
        .get("/article/getArticleById/" + 3)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.article = resp.data.data;
          }
        })
        .catch();
    }
  }
};
</script>

<style lang="scss">
.privacy-policy {
  margin-top: 67px;

  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }
}
</style>
